import React from 'react';
import { Routes, Route } from '@leagueplatform/routing';
import { SuccessPage } from '#components/success-page.view.jsx';
import { OutcomesPage } from '#components/outcomes/outcomes-page.component.tsx';
import { HealthAssessment } from './health-assessment-page.view';

export const AssessmentRoutes = () => (
  <Routes>
    <Route path="success" element={<SuccessPage />} />
    <Route path="outcomes" element={<OutcomesPage />} />
    <Route element={<HealthAssessment />} path="/*" />
  </Routes>
);
